/* global Skills */

import ApplicationController from './application_controller'

class SkillsController extends ApplicationController {
  static targets = ['settings']

  connect () {
    Skills.initHelpPopover($('.skills-comparison .skill-compare'), 'mleft10')

    document.addEventListener('click', (e) => {
      const line = e.target.closest('.line')
      if (!line) return
      if (e.target.classList.contains('star')) return

      if (line.classList.contains('open')) {
        line.classList.remove('open')
        line.classList.add('closed')
      } else if (line.classList.contains('closed')) {
        line.classList.remove('closed')
        line.classList.add('open')
      }
    })
  }
}

export default SkillsController
